import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=3a7c8e95&scoped=true&"
import script from "./Activity.vue?vue&type=script&lang=js&"
export * from "./Activity.vue?vue&type=script&lang=js&"
import style0 from "./Activity.vue?vue&type=style&index=0&id=3a7c8e95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7c8e95",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VListItemAvatar } from 'vuetify/lib'
import { VListItemContent } from 'vuetify/lib'
import { VListItemSubtitle } from 'vuetify/lib'
import { VListItemTitle } from 'vuetify/lib'
installComponents(component, {VDivider,VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
